import { api } from './client';

export type CmdbAssetType =
  | 'server' | 'vm' | 'container' | 'software' | 'service'
  | 'database' | 'storage' | 'network' | 'license' | 'integration' | 'other';

export type CmdbAssetStatus = 'draft' | 'active' | 'in_maintenance' | 'decommissioned';

export const CMDB_TYPE_LABEL: Record<CmdbAssetType, string> = {
  server: 'Сервер', vm: 'VM', container: 'Контейнер', software: 'ПО',
  service: 'Сервис', database: 'БД', storage: 'Хранилище',
  network: 'Сеть', license: 'Лицензия', integration: 'Интеграция', other: 'Прочее',
};

export const CMDB_STATUS_LABEL: Record<CmdbAssetStatus, string> = {
  draft: 'Черновик', active: 'Активен',
  in_maintenance: 'На обслуживании', decommissioned: 'Выведен из эксплуатации',
};

export interface CmdbAsset {
  id: string;
  organization_id: string;
  name: string;
  type: CmdbAssetType;
  status: CmdbAssetStatus;
  parent_id?: string | null;
  installation_id?: string | null;
  owner_user_id?: string | null;
  description?: string | null;
  metadata?: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export type CmdbAssetIn = {
  name: string;
  type: CmdbAssetType;
  status?: CmdbAssetStatus;
  parent_id?: string | null;
  installation_id?: string | null;
  owner_user_id?: string | null;
  description?: string | null;
  metadata?: Record<string, unknown> | null;
};

export const cmdbApi = {
  list: (orgId: string) =>
    api.get<CmdbAsset[]>(`/api/v1/organizations/${orgId}/cmdb`).then(r => r.data),
  create: (orgId: string, payload: CmdbAssetIn) =>
    api.post<CmdbAsset>(`/api/v1/organizations/${orgId}/cmdb`, payload).then(r => r.data),
  update: (orgId: string, id: string, payload: Partial<CmdbAssetIn>) =>
    api.patch<CmdbAsset>(`/api/v1/organizations/${orgId}/cmdb/${id}`, payload).then(r => r.data),
  delete: (orgId: string, id: string) =>
    api.delete(`/api/v1/organizations/${orgId}/cmdb/${id}`).then(r => r.data),
};
